<script>
    import Route, {router} from "./lib/Router/Router.svelte";
    import {APP_PATH, USER_COOKIE} from "./lib/constants";
    import {cookie} from "./lib/cookie";
    import R from "./lib/requests";
    import app from './stores/app';
    import user from "./stores/user";
    import Login from "./components/pages/Login.svelte";
    import AppHeader from "./components/AppHeader.svelte";
    import AppMenu from "./components/AppMenu.svelte";
    import Alert from "./components/Alert.svelte";
    import Notifier from './components/Notifier.svelte';
    import PageLoader from "./components/PageLoader.svelte";
    import PopupLoader from "./components/PopupLoader.svelte";
    import Users from "./users/Users.svelte";
    import Agents from "./agents/Agents.svelte";
    import Calendar from "./calendar/Calendar.svelte";
    import StopSales from "./stop_sales/StopSales.svelte";
    import UserEditModal from "./users/UserEditModal.svelte";
    import Reservations from "./reservations/Reservations.svelte";
    import Settings from "./workspace/Settings.svelte";

    let userInitialized = false;
    let appInitialized = false;

    const initUser = async () => {
        // user.initialize();
        let coo = cookie.get(USER_COOKIE) || null;
        if (coo && coo !== 'null') {
            $user.token = coo;
        }

        userInitialized = true;
    }

    const logoutUser = () => {
        user.clearToken();
        appInitialized = false;
        router.go('/app')();
    }

    const appInitialize = () => {
        const onSuccess = result => {
            user.setUser(result.user);

            app.setAgents(result.agents);
            app.setSettings(result.settings);

            appInitialized = true;
        }

        const onFailure = err => {
        };

        if (!$user.token) {
            console.log("NO USER TOKEN", $user.token);
            return;
        }

        R.handle(R.app.initialize, [], onSuccess, onFailure);
    }

    window.addEventListener('resize', function (event) {
        app.windowResize();
    });
    app.windowResize();

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && $app.escapeEventHandlers.length) {
            $app.escapeEventHandlers[$app.escapeEventHandlers.length - 1]();
        }
    });

    const menuAction = (action) => {
        if (action === 'logout') {

        }
    }

    initUser();

    $: {
        if ($user.token && !appInitialized) {
            appInitialize();
        }

        if (appInitialized) {
            if (window.location.pathname === "/" || window.location.pathname === "/app") {
                router.go("/app/calendar")();
            }
        }
    }
</script>


{#if !$user.token}
    <Login/>
{:else if appInitialized}
    <PageLoader/>
    <PopupLoader/>
    <AppHeader on:logout={ logoutUser }/>
    <AppMenu onLogOut={ logoutUser }/>
    <main>
        <div class="app-main-content">
            <div class="container-fluid">
                <Route match="/">
                    <Route match="{ APP_PATH }">
                        <Route match="calendar">
                            <Calendar/>
                        </Route>
                        <Route match="reservations" guard={user.isAdmin}>
                            <Reservations/>
                        </Route>
                        <Route match="agents" guard={user.isAdmin}>
                            <Agents/>
                        </Route>
                        <Route match="stop-sales" guard={user.isAdmin}>
                            <StopSales/>
                        </Route>
                        <Route match="users" guard={user.isAdmin}>
                            <Users/>
                        </Route>
                        <Route match="settings" guard={user.isAdmin}>
                            <Settings/>
                        </Route>
                    </Route>
                </Route>
            </div>
        </div>
    </main>
{/if}

{#if $app.edit_user != null}
    <UserEditModal userId={$app.edit_user.id} agentId={$app.edit_user.agent_id} closeCallback={$app.callbackFunction}/>
{/if}

<Alert/>
<Notifier/>

<style>
    main {
        width: 100%;
        padding-top: var(--header-height);
    }

    @media (max-width: 999px) {
        main .app-main-content {
            padding: 30px 0 0 0;
        }
    }

    @media (min-width: 1000px) and (max-width: 1024px) {
        main {
            padding-left: 50px;
        }

        main .app-main-content {
            padding: 30px 0 0 0;
        }
    }

    @media (min-width: 1025px) {
        main {
            padding-left: var(--aside-width);
        }

        main .app-main-content {
            padding: 30px 10px 20px 10px;
        }
    }
</style>